
import { IGetIndicadoresDropDownUseCase } from "../../../presentation/useCases/read/get_indicadores_dropdown_use_case";
import { IndicadoresDropDown } from "../../models/indicadores_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

//GetIndicadoresDropDownUseCase

export class GetIndicadoresDropDownUseCase implements IGetIndicadoresDropDownUseCase {
  constructor(
    private readonly repository: ICommonsRepository,
  ) { }

  async getIndicadoresDropDown(): Promise<IndicadoresDropDown[]> {
    const response = this.repository.getIndicadoresDropDown();
    return response;
  }
}